import moment from 'moment'

export function getFirstDayOfWeek(d) {
  return new Date(d.setDate(d.getDate() - d.getDay()))
}

export function getWeekArray(d, range = 7) {
  const firstDate = getFirstDayOfWeek(d)
  const weekArray = []

  let i = 1
  while (i <= range) {
    const dateToAdd = new Date(
      firstDate.getFullYear(),
      firstDate.getMonth(),
      firstDate.getDate() + i
    )
    weekArray.push(dateToAdd)
    i += 1
  }

  return weekArray
}

export function isEqualDate(d1, d2) {
  return moment(d1).format('DD/MM/YYYY') === moment(d2).format('DD/MM/YYYY')
  // return (
  //   d1 &&
  //   d2 &&
  //   d1.getFullYear() === d2.getFullYear() &&
  //   d1.getMonth() === d2.getMonth() &&
  //   d1.getDate() === d2.getDate()
  // )
}

export function cloneAsDate(d) {
  const clonedDate = cloneDate(d)
  clonedDate.setHours(0, 0, 0, 0)
  return clonedDate
}

export function cloneDate(d) {
  return new Date(d.getTime())
}

export function isBeforeDate(d1, d2) {
  const date1 = cloneAsDate(d1)
  const date2 = cloneAsDate(d2)

  return date1.getTime() < date2.getTime()
}

export function addDays(d, days = 0) {
  const newDate = cloneDate(d)
  newDate.setDate(d.getDate() + days)
  return newDate
}



// WEBPACK FOOTER //
// ./src/utils/dateUtils.js